var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/victory-pie/~/lodash/_Symbol.js
// module id = ./node_modules/victory-pie/node_modules/lodash/_Symbol.js
// module chunks = 1